import { useDispatch } from "react-redux";
import { debounce } from "../../../utils/hooks/useDebounce";
import {
  getPhotoSectionReissueList,
  updateConfig,
} from "../../../store/slices/PhotoSection/photoSectionOldCardReissueSlice";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
// import { startTimerRecheck } from "../api";
import { toast } from "react-toastify";

const usePhotoSectionReissue = () => {
  const dispatch = useDispatch();
  const [activeCard, setActiveCard] = useState({ id: "", key: "" });
  const [pendingPage, setPendingPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [clickedCardId, setClickedCardId] = useState(null);

  const photoSectionState = useSelector(
    (state) => state.photoSectionOldCardReissue,
  );
  const slug = sessionStorage?.getItem("slug");

  useEffect(() => {
    let params = {
      page: pendingPage,
      per_page: 10,
      process_slug: slug,
      search: photoSectionState?.searchReissue,
    };
    dispatch(getPhotoSectionReissueList(params));
    // eslint-disable-next-line
  }, [
    photoSectionState.currentPage,
    photoSectionState.currentPageSize,
    pendingPage,
  ]);

  const handleSearchInput = (e) => {
    const searchValue = e.target.value;
    dispatch(updateConfig((state) => (state.searchReissue = searchValue)));
  };

  // const startTimerPhoto = (item) => {
  //   if (!item?._id || clickedCardId === item._id) {
  //     return;
  //   }
  //   let body = {
  //     receipt_id: item?._id,
  //     process_slug: slug,
  //       order_type:3,
  //   };
  //   startTimerRecheck(body).then((response) => {
  //     if (response?.data?.status_code === 200) {
  //       toast.success("Timer Started");
  //       setClickedCardId(item?._id);
  //     } else {
  //       toast.error("Can't Start Timer");
  //     }
  //   });
  // };

  const handleCardClick = (e) => {
    setActiveCard({ id: e._id, key: "Pending" });
    // startTimerPhoto(e);
    dispatch(
      updateConfig((state) => {
        state.showTable = true;
        state.selectedId = e?._id;
        state.gli_id = e?.gli_number;
        state.currentPage = 1;
      }),
    );
  };

  const handleLoadMore = (mouseHover) => {
    if (
      mouseHover === "Pending" &&
      photoSectionState?.cardReissueData?.Pending?.length <=
        photoSectionState?.total?.Pending
    ) {
      setPendingPage(pendingPage + 1);
      setIsLoading(false);
    }
  };

  const handleSearch = () => {
    const searchValue = photoSectionState?.searchReissue;

    dispatch(
      updateConfig((state) => {
        state.cardReissueData.Pending = [];
      }),
    );
    dispatch(
      getPhotoSectionReissueList({
        search: searchValue,
        page: 1,
        process_slug: slug,
      }),
    );
  };
  return {
    activeCard,
    isLoading,
    photoSectionState,
    cardReissueData: photoSectionState?.cardReissueData,
    totalLength: { Pending: photoSectionState.total.Pending },
    apiStatus: { Pending: photoSectionState?.ReissuePendingCardStatus },
    setIsLoading,
    handleSearch,
    handleSearchInput,
    handleCardClick,
    handleLoadMore,
  };
};

export default usePhotoSectionReissue;
